import { registerExpressionNamespace } from '@natural-apptitude/coreo-expressions';
import {
  geometryAreaHa,
  geometryLengthKm,
  habitatName,
  ukhabBuildCombinedCode,
  ukhabConditionAssessment,
  ukhabConditionToScore,
  ukhabDenormalizeRecord,
  ukhabMapBaselineRawData,
  ukhabUkHabToMetric,
} from './ukhabExpressionPrimitives';
import { denormalizeUkhabRecord } from './ukhabRecordExpressionOutputs';

export const registerUkhabExpressions = (): void => {
  registerExpressionNamespace('ukhab', {
    denormalizeRecord: ukhabDenormalizeRecord,
    mapBaselineRawData: ukhabMapBaselineRawData,
    buildCombinedCode: ukhabBuildCombinedCode,
    ukHabToMetric: ukhabUkHabToMetric,
    conditionAssessment: ukhabConditionAssessment,
    conditionToScore: ukhabConditionToScore,
    habitatName,
    geometryAreaHa,
    geometryLengthKm,
    /** @deprecated Prefer primitives + fat data-events script. Kept for existing DB scripts. */
    runBaseline: (record: unknown) => denormalizeUkhabRecord(record, 'baseline'),
    /** @deprecated Prefer primitives + fat data-events script. Kept for existing DB scripts. */
    runPresurvey: (record: unknown) => denormalizeUkhabRecord(record, 'presurvey'),
  });
};
